<script setup lang="ts">
import KUIUnified404 from '~kui/components/KUI/Unified/404/KUIUnified404.vue';

import { useCoachRouter } from '~/composables/coach/useCoachRouter';

/**
 * What a public page shows inside the coach shell when the record it was opened on could not be
 * looked up (`usePageLookupFailure`): the not-found in the subpage, with the way back to the chat,
 * which stays mounted beside it. It is the whole page there, so its title is the page's h1.
 */
const { goBack } = useCoachRouter();
</script>

<template>
  <div class="flex flex-1 flex-col py-16" data-testid="coach-subpage-not-found">
    <KUIUnified404 heading-as="h1" @back="goBack({ toRoot: true })" />
  </div>
</template>
